var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.90625 9.00275H16.7344",
    stroke: "#A1A4A6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1562 11.5809L16.7344 9.00275L14.1562 6.42462",
    stroke: "#A1A4A6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5782 12.0938V15.1875C11.59 15.4484 11.4979 15.7034 11.3222 15.8967C11.1464 16.09 10.9013 16.2057 10.6404 16.2188H2.20275C1.94198 16.2056 1.69704 16.0897 1.52145 15.8965C1.34586 15.7032 1.25391 15.4483 1.26569 15.1875V2.8125C1.25372 2.55162 1.34561 2.29663 1.52124 2.10335C1.69687 1.91007 1.94192 1.79425 2.20275 1.78125H10.6404C10.9013 1.79425 11.1464 1.91005 11.3222 2.10331C11.4979 2.29656 11.59 2.55155 11.5782 2.8125V5.90625",
    stroke: "#A1A4A6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.fcf9895b938de9a59d6a2d0542cd174e.svg";
export { ForwardRef as ReactComponent };